  window.addEventListener('pageshow', function () {
    document.getElementById('country-selector').selectedIndex = 3;
  });
  
  document.addEventListener('DOMContentLoaded', function () {
    const countrySelector = document.getElementById('country-selector');

    countrySelector.addEventListener('change', function () {
      const url = this.value;
      if (url) {
        window.location.href = url;
      }
    });
  });

// Select all tab buttons
const tabButtons = document.querySelectorAll('.collection_filter_tabs  li button');

// Add click event listener to each button
tabButtons.forEach(button => {
    button.addEventListener('click', function() {
        // Remove 'active_tab' class from all buttons
        tabButtons.forEach(btn => btn.classList.remove('active_tab'));
        
        // Add 'active_tab' class to the clicked button
        this.classList.add('active_tab');
    });
}); 

// Optional: Add JavaScript to handle tab switching
document.querySelectorAll('.col_filter_tab button').forEach(button => {
    button.addEventListener('click', function() {
        // Remove active class from all buttons
        document.querySelectorAll('.col_filter_tab button').forEach(btn => btn.classList.remove('active_tab1'));
        
        // Hide all tab panes
        document.querySelectorAll('.collection_slider_main').forEach(pane => {
            pane.classList.remove('active');
            // Also remove active class from tab_collection_products
            pane.querySelector('.tab_collection_products')?.classList.remove('active');
        });

        // Remove active class from collection description
        document.querySelectorAll('.collection__description').forEach(desc => {
            desc.classList.remove('active');
        });

        // Add active class to clicked button
        this.classList.add('active_tab1');
        
        // Show corresponding tab pane
        const tabId = this.getAttribute('data-tab');
        const activePane = document.getElementById(tabId);
        
        if (activePane) {
            activePane.classList.add('active'); // Show the corresponding pane
            
            // Add active class to the specific sections within the active pane
            activePane.querySelector('.tab_collection_products')?.classList.add('active');

            // Add active class to collection__description if needed
            const description = document.querySelector('.collection__description[data-tab="' + tabId + '"]');
            if (description) {
                description.classList.add('active');
            }
        }
    });
});

document.querySelectorAll('.footer-accordion-header_desk').forEach(button => {
    button.addEventListener('click', function() {
        // Remove active class from all buttons
        document.querySelectorAll('.footer-accordion-header_desk').forEach(btn => btn.classList.remove('active'));
        
        // Hide all tab panes
        document.querySelectorAll('.footer-accordion-content_desk').forEach(pane => {
            pane.classList.remove('active');
            // Also remove active class from tab_collection_products
            pane.querySelector('.footer-accordion-content_desk')?.classList.remove('active');
        });

        
        // Show corresponding tab pane
        const tabId = this.getAttribute('data-tab');
        const activePane = document.getElementById(tabId);
        
        if (activePane) {
            activePane.classList.add('active'); // Show the corresponding pane
            
            // Add active class to the specific sections within the active pane
            activePane.querySelector('.footer-accordion-content_desk')?.classList.add('active');
          
           const description = document.querySelector('.footer-accordion-header_desk[data-tab="' + tabId + '"]');
            if (description) {
                description.classList.add('active');
            }

           
        }
    });
});

// Function to decide dragSize based on screen width
function getDragSize() {
  if (window.innerWidth <= 480) {
    return 86;
  } else if (window.innerWidth <= 990) {
    return 160;
  } else {
    return 326;
  }
}

// setTimeout(function() {
//   document.querySelectorAll('.product_collection-slider').forEach((sliderEl) => {
//     new Swiper(sliderEl, {
//       loop: false,
//       pagination: {
//         el: sliderEl.querySelector('.swiper-pagination'),
//         clickable: true,
//       },
//       scrollbar: {
//         el: sliderEl.querySelector('.swiper-scrollbar'),
//         draggable: true,
//         dragSize: getDragSize()
//       },
//       navigation: {
//         nextEl: sliderEl.querySelector('.swiper-button-next'),
//         prevEl: sliderEl.querySelector('.swiper-button-prev'),
//       },
//       slidesPerView: 'auto',
//       spaceBetween: 20,
//       on: {
//         init: function () {
//           // Use swiper.el to get the slider element
//           const prevButton = this.el.querySelector('.swiper-button-prev');
//           if (prevButton && this.isBeginning) {
//             prevButton.classList.add('swiper-button-disabled_cus');
//           }
//         },
//         slideChange: function () {
//           // Optionally update arrow states on slide change
//           const prevButton = this.el.querySelector('.swiper-button-prev');
//           const nextButton = this.el.querySelector('.swiper-button-next');
//           if (prevButton && nextButton) {
//             prevButton.classList.toggle('swiper-button-disabled_cus', this.isBeginning);
//             nextButton.classList.toggle('swiper-button-disabled_cus', this.isEnd);
//           }
//         }
//       }
//     });
//   });
// }, 2000); // Added a delay of 0 milliseconds, which defers execution until the stack is clear.

function featuredCollectionSliders(){
  document.querySelectorAll('.product_collection-slider').forEach((sliderEl) => {
    new Swiper(sliderEl, {
      loop: false,
      centeredSlidesBounds: true,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
      scrollbar: {
        el: sliderEl.querySelector('.swiper-scrollbar'),
        draggable: true,
        dragSize: getDragSize()
      },
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev'),
      },
      slidesPerView: 'auto',
      spaceBetween: 20,
      breakpoints: {
          // <= 768px → 1.5 slides per view
          0: {
            slidesPerView: 1.3,
            spaceBetween: 15
          },
          550: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true
          }
        },
      on: {
        init: function () {
          // Use swiper.el to get the slider element
          const prevButton = this.el.querySelector('.swiper-button-prev');
          if (prevButton && this.isBeginning) {
            prevButton.classList.add('swiper-button-disabled_cus');
          }
        },
        slideChange: function () {
          // Optionally update arrow states on slide change
          const prevButton = this.el.querySelector('.swiper-button-prev');
          const nextButton = this.el.querySelector('.swiper-button-next');
          if (prevButton && nextButton) {
            prevButton.classList.toggle('swiper-button-disabled_cus', this.isBeginning);
            nextButton.classList.toggle('swiper-button-disabled_cus', this.isEnd);
          }
        }
        // ,
        // setTranslate(swiper, translate) {
        //     if (window.innerWidth > 550) return; // only mobile

        //     const extra = 0;
        //     const wrapper = swiper.wrapperEl;
        //     const newTranslate = translate + extra;

        //     wrapper.style.transform = `translate3d(${newTranslate}px, 0, 0)`;
        //   }
      }
    });
  });
} 
// Added a delay of 0 milliseconds, which defers execution until the stack is clear.

// Run after DOM ready + with a few retries in case Swiper/section is late
document.addEventListener('DOMContentLoaded', () => {
  let attempts = 0;
  const maxAttempts = 10;
  const interval = setInterval(() => {
    attempts += 1;
    featuredCollectionSliders();
    if (attempts >= maxAttempts || document.querySelector('[data-swiper-initialized="true"]')) {
      clearInterval(interval);
    }
  }, 400);
}); 


        
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.mobile_nav_menu_slider', {
      loop: false, // Enable looping
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
     scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: '326'
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
   
    slidesPerView: 'auto', // Number of slides to show at once
      spaceBetween: 0, // Space between slides in pixels
      on: {
    init: function () {
        // const prevButton = document.querySelector('.swiper-button-prev');
        // if (prevButton) {
        //   prevButton.classList.add('swiper-button-disabled');
        // }
    }
       }
  });
  });
  

document.querySelectorAll('.footer-accordion-header').forEach(header => {
    header.addEventListener('click', () => {
        const content = header.nextElementSibling;
      
         // Toggle the display of the content
        if (content.style.display === 'block') {
            content.style.display = 'none';
            // Remove active class from header and content
            header.classList.remove('active');
            content.classList.remove('active-content');
        } else {
            content.style.display = 'block';
            // Add active class to header and content
            header.classList.add('active');
            content.classList.add('active-content'); 
        }
      
    });
});


  document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.querySelector('.LoadMoreButton');
  const productGrid = document.querySelector('.CollectionProductGrid');
  const counter = document.getElementById('ProductCounter');
  const progressFill = document.querySelector('.product-progress-fill');

    function updateProgress() {
  const shown = productGrid.querySelectorAll('.CollectionProductGrid .grid__item').length;
  const total = parseInt(counter.dataset.total, 10);
  const percent = Math.min((shown / total) * 100, 100);

  // Update counter text
  counter.textContent = `Showing ${shown} of ${total}`;
  // Update progress bar
  progressFill.style.width = `${percent}%`;
}

    
if (loadMoreBtn && productGrid && counter && progressFill) {
       updateProgress();
  
    loadMoreBtn.addEventListener('click', function () {
      const nextUrl = loadMoreBtn.dataset.nextUrl;

      fetch(nextUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('.CollectionProductGrid .grid__item');

          newItems.forEach(item => {
            productGrid.appendChild(item);
          });
        
          updateProgress();

           // Update the count
        const currentShown = productGrid.querySelectorAll('.CollectionProductGrid .grid__item').length;
        const total = counter.dataset.total;
        counter.textContent = `Showing ${currentShown} of ${total}`;
          
          const newNextBtn = doc.querySelector('.LoadMoreButton');
          if (newNextBtn) {
            loadMoreBtn.dataset.nextUrl = newNextBtn.dataset.nextUrl;
          } else {
            loadMoreBtn.remove(); // No more pages
          }
        });
    });
  }
});



document.querySelectorAll('.ingredients-slider').forEach((sliderEl) => {
  new Swiper(sliderEl, {
    loop: false,
    pagination: {
      el: sliderEl.querySelector('.swiper-pagination'),
      clickable: true,
    },
    scrollbar: {
      el: sliderEl.querySelector('.swiper-scrollbar'),
      draggable: true,
      dragSize: getDragSize()
    },
    navigation: {
      nextEl: sliderEl.querySelector('.swiper-button-next'),
      prevEl: sliderEl.querySelector('.swiper-button-prev'),
    },
    slidesPerView: 'auto',
    spaceBetween: 0,
    on: {
      init: function () {
        // Use swiper.el to get the slider element
        const prevButton = this.el.querySelector('.swiper-button-prev');
        if (prevButton && this.isBeginning) {
          prevButton.classList.add('swiper-button-disabled_cus');
        }
      },
      slideChange: function () {
        // Optionally update arrow states on slide change
        const prevButton = this.el.querySelector('.swiper-button-prev');
        const nextButton = this.el.querySelector('.swiper-button-next');
        if (prevButton && nextButton) {
          prevButton.classList.toggle('swiper-button-disabled_cus', this.isBeginning);
          nextButton.classList.toggle('swiper-button-disabled_cus', this.isEnd);
        }
      }
    }
  });
});


  const lazyImages = document.querySelectorAll('img.lazyload');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove('lazyload');
          obs.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => observer.observe(img));
  }


// Impact Page Slideshow Tabs
document.addEventListener('DOMContentLoaded', function () {
  const slideshowTabs = document.querySelector('.slideshow__tabs');

  if (slideshowTabs) {
    // Only run if .slideshow__tabs is present
    const tabItems = slideshowTabs.querySelectorAll('ul li');

    tabItems.forEach(tab => {
      tab.addEventListener('click', function () {
        // Remove 'active' from all tabs
        tabItems.forEach(t => t.classList.remove('active'));

        // Add 'active' to the clicked one
        this.classList.add('active');
      });
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".slideshow__tabs__mobile");

  if (container) {
    const dropdown = container.querySelector(".dropdown");
    const subDropdown = container.querySelector(".sub-dropdown");

    if (dropdown && subDropdown) {
      dropdown.addEventListener("click", function () {
        subDropdown.classList.toggle("active");
        dropdown.classList.toggle("open"); // Toggle rotation
      });
    }
  }
});

//Local Impact Page Tab switcher
document.addEventListener('DOMContentLoaded', function () {
  const contents = document.querySelectorAll('.tab-content-container');

  // Handle tab switch logic (shared for mobile and desktop)
  function handleTabClick(tabElements, activeClass, index, tabsSelector) {
    // Remove active class from all in that tab group
    tabElements.forEach(t => t.classList.remove(activeClass));
    tabElements[index].classList.add(activeClass);
    
    // Show correct content
    contents.forEach(c => c.classList.remove('active'));
    if (contents[index]) contents[index].classList.add('active');

    // Sync with the other tab group
    if (tabsSelector === '.tabs-pills') {
      const mobileTabs = document.querySelectorAll('.mobile-tabs-pills span');
      mobileTabs.forEach(m => m.classList.remove('active-pill'));
      if (mobileTabs[index]) mobileTabs[index].classList.add('active-pill');
    } else {
      const desktopTabs = document.querySelectorAll('.tabs-pills li');
      desktopTabs.forEach(d => d.classList.remove('active'));
      if (desktopTabs[index]) desktopTabs[index].classList.add('active');
    }
  }

  // Setup desktop tab click
  const desktopTabsWrapper = document.querySelector('.tabs-pills');
  if (desktopTabsWrapper) {
    const desktopTabs = desktopTabsWrapper.querySelectorAll('li');
    desktopTabs.forEach((tab, index) => {
      tab.addEventListener('click', function () {
        handleTabClick(desktopTabs, 'active', index, '.tabs-pills');
      });
    });
  }

  // Setup mobile tab click with expand/collapse logic
  const mobileTabsWrapper = document.querySelector('.mobile-tabs-pills');
  if (mobileTabsWrapper) {
    const mobileTabs = mobileTabsWrapper.querySelectorAll('span');

    mobileTabs.forEach((tab, index) => {
      tab.addEventListener('click', function () {
        const isExpanded = [...mobileTabs].every(span => getComputedStyle(span).display === 'block');

        if (!isExpanded) {
          // Expand all spans
          mobileTabs.forEach(t => t.style.display = 'block');
        } else {
          // Collapse: set clicked one as active, hide others
          mobileTabs.forEach(t => {
            t.classList.remove('active-pill');
            t.style.display = 'none';
          });
          this.classList.add('active-pill');
          this.style.display = 'block';

          // Sync content
          handleTabClick(mobileTabs, 'active-pill', index, '.mobile-tabs-pills');
        }
      });
    });
  }
});
